import {
  convertCentsToMajorUnit,
  formatAmountWithCommas,
  getLocalizedCurrency
} from "@unified-checkout/design-system";
import type { IBadge } from "libs/design-system/src/types/Badge/badge";
import type { TDisputeStatus } from "@app/dashboard/types/innerLayout/disputes";


export const statusBadgePropsMap: Record<TDisputeStatus, IBadge> = {
  'Action required': { color: "yellow" },
  'Under review': { color: "primary" },
  'Closed': { color: "green" },
};

export const NO_VALUE = '-';
export const EVIDENCE_ALLOWED_FORMATS = [".png", ".jpeg", ".jpg", ".pdf"];

export const DAWER_TOASTER_MAX_WIDTH = '15.625rem';
export const GENERIC_TOASTER_MAX_WIDTH = '30rem';
export const TOASTER_TIMEOUT = 4;
export const TOASTER_SHARED_PROPS = {
  maxWidth: DAWER_TOASTER_MAX_WIDTH,
  timeout: TOASTER_TIMEOUT
} as const;

export const formatValues = (currency: string, amount: number, lang: 'en' | 'ar') => {
  const majorUnitAmount = convertCentsToMajorUnit(amount, currency);
  const formattedAmount = formatAmountWithCommas({ amount: majorUnitAmount as number, currency });

  const localizedCurrency = currency ? getLocalizedCurrency(lang, currency) : '';

  return `
  ${lang === 'en' ? localizedCurrency : ''}
  ${formattedAmount}
  ${lang === 'ar' ? localizedCurrency : ''}
  `
};

export const sharedActionBtnsProps = {
  main: {
    size: 'lg',
    color: 'primary',
    variant: 'contained',
  },
  secondary: {
    size: 'lg',
    color: 'secondary',
    variant: 'link',
  }
} as const;